import * as Yup from 'yup';

import Auth from '../../api/auth';
import { FormModal } from '../../components/Formik';
import { regexValidator } from '../../helpers/regexValidator';
import useApiQuery from '../../hooks/useApiQuery';

import type { Organization } from '@/types/organization';

interface CreateOrganizationFormModalProps {
  onSubmit: (data: Organization) => void;
  onCancel: () => void;
}

const CreateOrganizationFormModal: React.FC<CreateOrganizationFormModalProps> = ({ onSubmit, onCancel }) => {
  const { makeApiCall: createOrganizationCall } = useApiQuery(Auth.createV1Organization as unknown as (args: unknown) => Promise<unknown>, {
    successMessage: 'organizationCreated',
  });

  const fields = [
    {
      fieldType: 'text',
      name: 'enterpriseName',
      label: 'Organization name',
    },
    {
      fieldType: 'text',
      name: 'CRMId',
      label: 'CRM Id',
    },
  ];

  const initialValues = {
    enterpriseName: '',
    CRMId: '',
  };

  const validationSchema = Yup.object().shape({
    enterpriseName: Yup.string()
      .required('Required')
      .matches(
        regexValidator.name,
        'Start with letter, all lower-case, no spaces, no special characters(dash only)'
      ),
  });

  const createOrganization = async (formValues: Record<string, unknown>): Promise<void> => {
    onCancel();
    try {
      const data = (await createOrganizationCall(formValues)) as Organization;
      onSubmit(data);

    } catch (error) {
      console.error('Error creating organization:', error);
    }

  };

  return (
    <FormModal
      title='Create New Organization'
      fields={fields}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values: Record<string, unknown>) => {
        createOrganization(values);
      }}
      onCancel={onCancel}
      submitLabel='Create'
    />
  );
};

export default CreateOrganizationFormModal;
